import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxMaskModule } from 'ngx-mask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { ViggoCoreComponentsModule } from 'viggo-sistemas-core-web';
import { AutoCompleteCondicaoPagtoComponent } from './components/autocomplete-cond-pagtos-catalogo/autocomplete-cond-pagtos-catalogo.component';
import { FastAutocompleteProdutoVariacoesComponent } from './components/autocomplete-produto-variacoes/autocomplete-produto-variacoes.component';
import { AutoCompleteSeries } from './components/autocomplete-series/autocomplete-series.component';
import { AutoCompleteUsers } from './components/autocomplete-users/autocomplete-users.component';
import { FastAutocompleteVariacoesComponent } from './components/autocomplete-variacoes/autocomplete-variacoes.component';
import { ChipInputComponent } from './components/chip-input/chip-input.component';
import { FastClientesCarteiraComponent } from './components/clientes_carteira/clientes_carteira.component';
import { DialogDelContatoComponent } from './components/dialog-del-contato/dialog-del-contato.component';
import { DialogEditContatoComponent } from './components/dialog-edit-contato/dialog-edit-contato.component';
import { DialogSearchNCMComponent } from './components/dialog-search/dialog-search-ncm.component';
import { FastAppHeaderComponent } from './components/fast-app-header/fast-app-header.component';
import { FastAutocompleteComponent } from './components/fast-autocomplete/fast-autocomplete.component';
import { FastCentroResultadoComponent } from './components/fast-centro-resultado/fast-centro-resultado.component';
import { FastClientsComponent } from './components/fast-clients/fast-clients.component';
import { FastCondPgmtComponent } from './components/fast-cond-pgmt/fast-cond-pgmt.component';
import { FastContatoComponent } from './components/fast-contato/fast-contato.component';
import { FastCodigoSegContribuinteComponent } from './components/fast-csc/fast-csc.component';
import { FastEnderecoComponent } from './components/fast-endereco/fast-endereco.component';
import { FastFabricanteComponent } from './components/fast-fabricante/fast-fabricante.component';
import { FastFormaPgmtComponent } from './components/fast-forma-pgmt/fast-forma-pgmt.component';
import { FastFornecedorComponent } from './components/fast-fornecedor/fast-fornecedor.component';
import { FastGrupoComponent } from './components/fast-grupo/fast-grupo.component';
import { FastInstituicaoComponent } from './components/fast-instituicao/fast-instituicao.component';
import { FastNaturezaFinanceiraComponent } from './components/fast-natureza-financeira/fast-natureza-financeira.component';
import { FastParceiroComponent } from './components/fast-parceiro/fast-parceiro.component';
import { FastPrecoProdutoComponent } from './components/fast-preco-produto/fast-preco-produto.component';
import { TableFastCbenefsComponent } from './components/fast-produto-fiscal/components/table-cbenefs/table-fast-cbenefs.component';
import { TableFastMvasComponent } from './components/fast-produto-fiscal/components/table-mvas/table-fast-mvas.component';
import { TableFastRegrasFiscaisComponent } from './components/fast-produto-fiscal/components/table-regras-fiscais/table-fast-regras-fiscais.component';
import { FastProdutoFiscalComponent } from './components/fast-produto-fiscal/fast-produto-fiscal.component';
import { AppFormProdutoVariacoesComponent } from './components/fast-produto/components/app-form-produto-variacoes/app-form-produto-variacoes.component';
import { AppTableProdutosVariacaoComponent } from './components/fast-produto/components/table-produto-variacoes/app-table-produto-variacoes.component';
import { FastProdutoComponent } from './components/fast-produto/fast-produto.component';
import { FastRegraFiscalComponent } from './components/fast-regra-fiscal/fast-regra-fiscal.component';
import { FastSerieFiscalComponent } from './components/fast-serie-fiscal/fast-serie-fiscal.component';
import { FastSupervisorComponent } from './components/fast-supervisor/fast-supervisor.component';
import { FastTabelaComponent } from './components/fast-tabela/fast-tabela.component';
import { FastTipoOperacaoComponent } from './components/fast-tipo-operacao/fast-tipo-operacao.component';
import { FastUFIcmsComponent } from './components/fast-uficms/fast-uficms.component';
import { FastUnidadeComponent } from './components/fast-unidade/fast-unidade.component';
import { FastVariacaoProdutoComponent } from './components/fast-variacao-produto/fast-variacao-produto.component';
import { FastVendedorComponent } from './components/fast-vendedor/fast-vendedor.component';
import { FastCondPagtoComponent } from './components/fav_cond_pagto/fav_cond_pagto.component';
import { NcmIbptAutoCompleteComponent } from './components/ncm-autocomplete/ncm-autocomplete.component';
import { ProdutoFiscalAutoCompleteComponent } from './components/produto-fiscal-autocomplete/produto-fiscal-autocomplete.component';
import { FastFormatCpfCnpjDirective } from './directive/fast-cpf_cnpj.directive';
import { FastFormatDataDirective } from './directive/fast-date.directive';
import { FastHeaderFormatDirective } from './directive/fast-header.directive';

@NgModule({
  declarations: [
    FastClientsComponent,
    FastEnderecoComponent,
    FastGrupoComponent,
    FastAutocompleteComponent,
    FastUnidadeComponent,
    FastFornecedorComponent,
    FastParceiroComponent,
    FastContatoComponent,
    DialogEditContatoComponent,
    DialogDelContatoComponent,
    FastProdutoComponent,
    FastVendedorComponent,
    FastFormatDataDirective,
    FastTabelaComponent,
    FastFormaPgmtComponent,
    FastCondPgmtComponent,
    FastAppHeaderComponent,
    FastHeaderFormatDirective,
    FastPrecoProdutoComponent,
    FastFabricanteComponent,
    FastSupervisorComponent,
    FastFormatCpfCnpjDirective,
    FastTipoOperacaoComponent,
    FastRegraFiscalComponent,
    FastProdutoFiscalComponent,
    FastInstituicaoComponent,
    TableFastRegrasFiscaisComponent,
    TableFastMvasComponent,
    TableFastCbenefsComponent,
    FastCodigoSegContribuinteComponent,
    ChipInputComponent,
    NcmIbptAutoCompleteComponent,
    DialogSearchNCMComponent,
    AutoCompleteUsers,
    AutoCompleteSeries,
    FastClientesCarteiraComponent,
    ProdutoFiscalAutoCompleteComponent,
    FastCondPagtoComponent,
    FastSerieFiscalComponent,
    FastCentroResultadoComponent,
    FastNaturezaFinanceiraComponent,
    FastUFIcmsComponent,
    AutoCompleteCondicaoPagtoComponent,
    FastVariacaoProdutoComponent,
    FastAutocompleteVariacoesComponent,
    FastAutocompleteProdutoVariacoesComponent,
    AppTableProdutosVariacaoComponent,
    AppFormProdutoVariacoesComponent
  ],
  imports: [
    CommonModule,
    NgxMaskModule.forChild(),
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTabsModule,
    MatButtonModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ViggoCoreComponentsModule,
    MatCheckboxModule,
    MatDividerModule,
    MatListModule,
    MatIconModule,
    MatChipsModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatTableModule,
    MatMenuModule,
    MatPaginatorModule,
    //primeng modules
    AutoCompleteModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    RippleModule,
    ButtonModule,
    StyleClassModule,
    InputMaskModule,
    TableModule
  ],
  exports: [
    FastAutocompleteComponent,
    FastFormaPgmtComponent,
    FastCondPgmtComponent,
    FastClientsComponent,
    FastTipoOperacaoComponent,
    FastRegraFiscalComponent,
    FastProdutoFiscalComponent,
    FastInstituicaoComponent,
    TableFastRegrasFiscaisComponent,
    TableFastMvasComponent,
    TableFastCbenefsComponent,
    FastCodigoSegContribuinteComponent,
    NcmIbptAutoCompleteComponent,
    DialogSearchNCMComponent,
    FastClientesCarteiraComponent,
    AutoCompleteUsers,
    AutoCompleteSeries,
    ProdutoFiscalAutoCompleteComponent,
    FastCondPagtoComponent,
    FastUFIcmsComponent,
    AutoCompleteCondicaoPagtoComponent,
    FastAutocompleteVariacoesComponent,
    FastAutocompleteProdutoVariacoesComponent
  ]
})
export class FastCadastroModule {}
